<header class="parent-dialog__header" mat-dialog-title>
  <div class="parent-dialog__header-main">
    <div class="parent-dialog__header-icon" aria-hidden="true">
      <img src="/public/svgs/edit-dark.svg" alt="" width="18" height="18" />
    </div>
    <div class="parent-dialog__header-copy">
      <h2 class="parent-dialog__title">
        {{ 'app.admin.contentPage.edit.title' | translate }}
      </h2>
      <p class="parent-dialog__subtitle">
        {{ 'app.admin.contentPage.edit.subtitle' | translate }}
      </p>
    </div>
  </div>
  <button
    type="button"
    class="parent-dialog__close"
    [attr.aria-label]="'app.admin.contentPage.edit.close' | translate"
    (click)="onDiscard()"
  >
    <img src="/public/svgs/x-close.svg" alt="" width="18" height="18" aria-hidden="true" />
  </button>
</header>

<mat-dialog-content class="parent-dialog__body course-edit">
  <p class="parent-dialog__hint">{{ 'app.admin.contentPage.edit.hint' | translate }}</p>

  <section class="parent-dialog__section">
    <span class="parent-dialog__section-label">{{
      'app.admin.contentPage.edit.overview' | translate
    }}</span>

    <div class="course-edit__form">
      <div class="course-edit__row">
        <app-input-field
          [label]="'app.admin.contentPage.edit.courseName' | translate"
          [ngModel]="courseName()"
          (ngModelChange)="courseName.set($event)"
        />
        <app-input-field
          [label]="'app.admin.contentPage.edit.category' | translate"
          [ngModel]="category()"
          (ngModelChange)="category.set($event)"
        />
      </div>

      <app-input-field
        [inputType]="'textarea'"
        [label]="'app.admin.contentPage.edit.description' | translate"
        [ngModel]="courseDescription()"
        (ngModelChange)="courseDescription.set($event)"
      />

      <div class="course-edit__row">
        <app-input-field
          [type]="'number'"
          [label]="'app.admin.contentPage.edit.duration' | translate"
          [ngModel]="estimatedDuration()"
          (ngModelChange)="estimatedDuration.set(+$event || 0)"
        />
        <app-input-field
          [label]="'app.admin.contentPage.edit.coverPath' | translate"
          [placeholder]="'app.admin.contentPage.edit.storagePathPlaceholder' | translate"
          [ngModel]="courseImageUrl()"
          (ngModelChange)="courseImageUrl.set($event)"
        />
      </div>

      <div class="course-edit__cover-row">
        @if (courseCoverPreviewUrl(); as coverSrc) {
          <div class="course-edit__preview">
            <img [src]="coverSrc" [alt]="course().courseName" />
          </div>
        }
        <div class="course-edit__file-action">
          <input
            #coverInput
            type="file"
            hidden
            accept="image/png,image/jpeg,image/jpg,image/webp"
            (change)="onCoverSelected($event)"
          />
          <app-parent-button
            variant="ghost"
            [disabled]="isUploading()"
            [loading]="isUploading()"
            (clicked)="coverInput.click()"
          >
            {{ 'app.admin.contentPage.edit.chooseFile' | translate }}
          </app-parent-button>
        </div>
      </div>

      <label class="course-edit__checkbox">
        <input
          type="checkbox"
          [ngModel]="identityMandatory()"
          (ngModelChange)="identityMandatory.set($event)"
        />
        <span>{{ 'app.admin.contentPage.edit.identityMandatory' | translate }}</span>
      </label>
      <p class="parent-dialog__hint course-edit__checkbox-hint">
        {{ 'app.admin.contentPage.edit.identityMandatoryHint' | translate }}
      </p>
    </div>
  </section>

  <section class="parent-dialog__section">
    <span class="parent-dialog__section-label">{{
      'app.admin.contentPage.edit.lessons' | translate
    }}</span>

    @for (lesson of lessons(); track lesson.taskId; let i = $index) {
      <article class="course-edit__lesson">
        <h4 class="course-edit__lesson-title">
          {{ 'app.admin.contentPage.edit.lesson' | translate }} {{ i + 1 }}
        </h4>
        <div class="course-edit__form">
          <app-input-field
            [label]="'app.admin.contentPage.edit.lessonTitle' | translate"
            [ngModel]="lesson.title"
            (ngModelChange)="updateLesson(lesson.taskId, 'title', $event)"
          />
          <app-input-field
            [inputType]="'textarea'"
            [label]="'app.admin.contentPage.edit.lessonDescription' | translate"
            [ngModel]="lesson.description"
            (ngModelChange)="updateLesson(lesson.taskId, 'description', $event)"
          />
          <app-input-field
            [label]="'app.admin.contentPage.edit.contentUrl' | translate"
            [placeholder]="'app.admin.contentPage.edit.storagePathPlaceholder' | translate"
            [ngModel]="lesson.contentUrl"
            (ngModelChange)="updateLesson(lesson.taskId, 'contentUrl', $event)"
          />
          <div class="course-edit__row">
            <app-input-field
              [label]="'app.admin.contentPage.edit.audioUrl' | translate"
              [placeholder]="'app.admin.contentPage.edit.storagePathPlaceholder' | translate"
              [ngModel]="lesson.audioUrl"
              (ngModelChange)="updateLesson(lesson.taskId, 'audioUrl', $event)"
            />
            <app-input-field
              [label]="'app.admin.contentPage.edit.scriptUrl' | translate"
              [placeholder]="'app.admin.contentPage.edit.storagePathPlaceholder' | translate"
              [ngModel]="lesson.scriptUrl"
              (ngModelChange)="updateLesson(lesson.taskId, 'scriptUrl', $event)"
            />
          </div>
          <div class="course-edit__cover-row">
            @if (lessonCoverUrl(lesson.taskId); as coverSrc) {
              <div class="course-edit__preview">
                <img [src]="coverSrc" [alt]="lesson.title" />
              </div>
            }
            <div class="course-edit__file-action">
              <input
                #thumbInput
                type="file"
                hidden
                accept="image/png,image/jpeg,image/jpg,image/webp"
                (change)="onLessonThumbnailSelected(lesson.taskId, $event)"
              />
              <app-parent-button
                variant="ghost"
                [disabled]="isUploading()"
                [loading]="isUploading()"
                (clicked)="thumbInput.click()"
              >
                {{ 'app.admin.contentPage.edit.chooseThumbnail' | translate }}
              </app-parent-button>
            </div>
          </div>
        </div>
      </article>
    }
  </section>

  @if (saveError(); as errKey) {
    <p class="course-edit__error" role="alert">{{ errKey | translate }}</p>
  }
</mat-dialog-content>

<mat-dialog-actions align="end" class="parent-dialog__actions parent-dialog-actions">
  <app-parent-button variant="ghost" (clicked)="onDiscard()">
    {{ 'app.admin.contentPage.edit.discard' | translate }}
  </app-parent-button>
  <app-parent-button
    variant="primary"
    [disabled]="isSaving() || isUploading()"
    [loading]="isSaving()"
    (clicked)="onSave()"
  >
    {{ 'app.admin.contentPage.edit.save' | translate }}
  </app-parent-button>
</mat-dialog-actions>
